import React,{useCallback,useContext, useState,useRef,useEffect} from 'react';
import { getRequest, postRequest, deleteRequest } from '../../api/ApiController';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { ReactTabulator,reactFormatter } from 'react-tabulator';
import '../../assets/css/style.css';
import '../../assets/css/iconsmenu.css'
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css"
import { AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon,EditRowIcon} from "../svg/svgIcons";
import UtilContext from '../../components/UtilContext';
import { OverflowMenuProvider } from '../../components/toolbar/OverflowMenu';
import IntersectionObserverWrapper from '../../components/toolbar/IntersectionObserverWrap';
import { scrollToFirst as scrollToFirstUtil, scrollUp as scrollUpUtil, scrollDown as scrollDownUtil, scrollToLast as scrollToLastUtil } from '../../utils/tabulatorScroll';
import { resetTabulatorMask } from '../../utils/tabulatorResetMask';
import { Checkbox } from 'primereact/checkbox';
import { PanelMenu } from 'primereact/panelmenu';
import { Avatar } from 'primereact/avatar';
import AuthContext from '../../components/AuthContext';
import { LocaleContext } from '../../components/LocaleContext';
import { defaultProductLogoSrc } from '../../constants/brandingDisplay';
import { buildCanonicalPrintFooterHtml, buildCanonicalPrintHeaderHtml } from '../../utils/printChrome';
import { canCreateChecklistRecord } from '../../utils/checklistRecordCreateHttp';
import { applyTabulatorRuntimeI18n } from '../../utils/tabulatorRuntimeI18n';

const CHECKLIST_RECORD_LIST_COLUMN_I18N_KEYS = Object.freeze({
  name: 'Common.Name',
  'machine.name': 'Common.Machine',
  custom_department: 'Common.Department',
  users: 'Common.Employee',
  sending_data: 'ChecklistTemplate.Column.Intensity',
  manager_name: 'Checklist.ResponsibleManager',
  manager_due_days: 'ChecklistTemplate.Column.ManagerDueDays',
  description: 'Common.Description',
});

export default function ChecklistRecordList(){

  const [state,dispatch] = useContext(DatabaseContext);
  const {user} = useContext(AuthContext);
  const { t, locale } = useContext(LocaleContext);
  const canCreate = canCreateChecklistRecord(user);
  const {setDialogText,setVisible,openFavoriteDialog,toast,setFastView,setUserMaskFilter,getUserInitials,getUserColor, openChosenNotificationPreferences} = useContext(UtilContext);

  const [stepBackIcon,setStepBackIcon] = useState(true);
  const [editIcon,setEditIcon] = useState(true);
  const [deleteIcon,setDeleteIcon] = useState(true);
  const [favoriteIcon,setFavoriteIcon] = useState(false);
  const [copyIcon,setCopyIcon] = useState(true);

  const [markUnmark, setMarkUnmarked] = useState(true);

  const [visibleSearch,setVisibleSearch] = useState(false);
  const [searchValue,setSearchValue] = useState('');

    const [editFormDepartment, setEditFormDepartment] = useState([]);

  const DEFAULT_COLUMNS_VISIBLE_RECORD = { name: true, "machine.name": true, custom_department: true, users: true, sending_data: true, manager_name: true, manager_due_days: true, description: true };
  const [columnsVisible, setColumnsVisible] = useState({ ...DEFAULT_COLUMNS_VISIBLE_RECORD });
  const [maskVisible, setMaskVisible] = useState(false);
const ref = useRef(null);
    const elementRef = useRef(null);
    const overlayRef = useRef(null);
    const getTable = useCallback(() => ref.current?.table ?? ref.current, []);

  useEffect(() => {
    const table = typeof getTable === 'function' ? getTable() : null;
    if (!table?.getColumns) return;
    applyTabulatorRuntimeI18n(table, t, {
      columnTitleKeys: CHECKLIST_RECORD_LIST_COLUMN_I18N_KEYS,
      placeholder: typeof t === 'function' ? t('Common.NoData') : undefined,
      reformatRows: true,
    });
  }, [locale, t, getTable]);

    function matchAny(data, filterParams) {
      var match = false;
      const regex = RegExp(filterParams.value, 'i');
      for (var key in data) {
          if (regex.test(data[key]) === true) {
              match = true;
          }
      }
      return match;
    }

    function searchTable(){
      ref.current.setFilter(matchAny, { value: searchValue});
      if (searchValue === " ") {
        ref.current.clearFilter()
      }
      setVisibleSearch(false);
    }

    const accept = () => {
        const rows_to_delete = ref.current.getSelectedData();
        setDialogText(t('Common.Deleting'));
        setVisible(true);

        const deletePromises = rows_to_delete.map((element) =>
            deleteRequest(`/api/checklist_records/${element.id}`)
        );

        Promise.allSettled(deletePromises).then((results) => {
            setVisible(false);
            const successCount = results.filter(r => r.status === "fulfilled").length;
            const failCount = results.filter(r => r.status === "rejected").length;

            if (successCount > 0 && failCount === 0) {
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), detail: t('Common.Toast.RecordsDeletedDetail').replace('{{count}}', String(successCount)), life: 3000 });
            } else if (successCount > 0 && failCount > 0) {
                toast?.current?.show({ severity: 'warn', summary: t('Common.Toast.PartialDeletedSummary'), detail: t('Common.Toast.PartialDeletedDetail').replace('{{success}}', String(successCount)).replace('{{fail}}', String(failCount)), life: 3000 });
            } else {
                toast?.current?.show({ severity: 'error', summary: t('Common.Error'), detail: t('Common.Toast.NoneDeletedDetail'), life: 3000 });
            }

            const successIds = results
                .map((r, i) => (r.status === "fulfilled" ? rows_to_delete[i]?.id : null))
                .filter(Boolean);
            if (successIds.length > 0) {
                dispatch({
                    type: 'load_checklist_records',
                    newChecklistRecords: (state.checklist_records || []).filter((r) => !successIds.includes(r.id))
                });
                if (user?.permissions?.includes("edit checklists")) {
                    dispatch({
                        type: 'load_checklist_state_records',
                        newChecklistStateRecords: (state.checklist_state_records || []).filter((r) => !successIds.includes(r.id))
                    });
                }
                if (user?.is_superuser == 1) {
                    dispatch({
                        type: 'load_checklist_all_records',
                        newChecklistAllRecords: (state.checklist_all_records || []).filter((r) => !successIds.includes(r.id))
                    });
                }
            }
        });
    };

const reject = () => {
    toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
}

const confirm = () => {
    confirmDialog({
        message: t('ServiceTask.ConfirmDeleteRecord'),
        header: t('Common.ConfirmDelete'),
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: t('Common.Yes'),
        rejectLabel: t('Common.No'),
        accept,
        reject
    });
};

const rowClick = (e, row) => {
    console.log(e, row);
};

const onSelectRow = (data, rows) => {
  setEditIcon(true);
  setCopyIcon(true);
  setDeleteIcon(true);
  if(ref.current.getSelectedData().length === 1){
      if(canCreate)setEditIcon(false);
      if(user.permissions?.includes("delete checklists"))setDeleteIcon(false);
      if(canCreate)setCopyIcon(false);
      setEditFormDepartment(data);  
  }
};

function onEditRow(row){
  if (!canCreate) return;
  const props = { checklist_template: row, type: 'edit' };
  if (row?.original_user_id != null) props.original_user_id = row.original_user_id;
  dispatch({type:'create_new_tab',name:t('Checklist.EditRecord'), translationKey: 'Checklist.EditRecord', legacyLabel: t('Checklist.EditRecord'), page:'ChecklistRecordAdd',props,mask:'chck004'})
};

function EditRowFormatter(props) {
  const rowData = props.cell.getRow().getData();
  if (!canCreate) return null;
  return <div className='flex items-center justify-center w-full h-full'><button type='button' onClick={() => onEditRow(rowData)}><EditRowIcon/></button></div>;
}

function removeDiacritics(str) {
    return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

const extractDepartmentsFromRecipients = (recipients) => {
      const departmentMap = new Map();

      recipients.forEach((user) => {
          const dept = user?.employee?.department;
          if (dept && !departmentMap.has(dept.id)) {
          departmentMap.set(dept.id, {
              id: dept.id,
              name: dept.name,
              searchLabel: removeDiacritics(dept.name).toLowerCase(),
          });
          }
      });

      return Array.from(departmentMap.values());
  };

function DepartmentFormatter(props) {
    const rowData = props.cell.getRow().getData();
    return extractDepartmentsFromRecipients(rowData?.users).map(departmnent => departmnent?.name).join(', ')
}

function departmentFilter(headerValue, rowValue, rowData, filterParams) {
  if (!headerValue) return true;

  const normalizedSearch = removeDiacritics(headerValue).toLowerCase();

  return rowData?.users?.some(user => {
    const dept = user?.employee?.department_id;
    if (!dept) return false;
    let found = state?.departments.find(department => department?.id == dept);
    return removeDiacritics(found?.name).toLowerCase().includes(normalizedSearch);
  });
}

function UserFormatter(props) {
    const rowData = props.cell.getRow().getData();
    const isSubstitute = rowData?.substitute_user_id != null;
    const originalUserId = rowData?.original_user_id;
    const originalUserName = rowData?.original_user_name || '';
    if (isSubstitute && originalUserId != null) {
      const originalUser = (rowData?.users || []).find((u) => u?.id === originalUserId);
      const avatar = originalUser ? (
        <Avatar title={originalUser?.employee?.name || originalUser?.username} label={getUserInitials(originalUser?.employee?.name || originalUser?.username)} shape="circle" style={{ backgroundColor: getUserColor(originalUser?.username), color: '#ffffff', marginRight: '6px' }} />
      ) : (
        <Avatar title={originalUserName} label={getUserInitials(originalUserName)} shape="circle" style={{ backgroundColor: getUserColor(originalUserName), color: '#ffffff', marginRight: '6px' }} />
      );
      return (
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '4px', lineHeight: 1 }}>
          <span style={{ position: 'relative', display: 'inline-block', lineHeight: 0 }}>
            {avatar}
            <span
              className="p-badge p-badge-info"
              style={{ position: 'absolute', top: '-2px', right: '-2px', fontSize: '0.75rem', minWidth: '14px', height: '14px', lineHeight: '14px', padding: '0 3px' }}
            >
              Z
            </span>
          </span>
        </span>
      );
    }
    return (rowData?.users || []).map((u) => (
      <Avatar key={u?.id} title={u?.employee?.name || u?.username} label={getUserInitials(u?.employee?.name || u?.username)} shape="circle" style={{ backgroundColor: getUserColor(u?.username), color: '#ffffff', marginRight: '5px' }} />
    ));
}

function userFilter(headerValue, rowValue, rowData, filterParams) {
  if (!headerValue) return true;

  const normalizedSearch = removeDiacritics(headerValue).toLowerCase();

  return rowData?.users?.some(user => {
    const dept = user?.employee?.name || user?.username;
    if (!dept) return false;
    return removeDiacritics(dept).toLowerCase().includes(normalizedSearch);
  });
}

  function ManagerFormatter(props) {
      const rowData = props.cell.getRow().getData();
      return <Avatar title={rowData?.manager?.employee?.name || rowData?.manager?.username} label={getUserInitials(rowData?.manager?.employee?.name || rowData?.manager?.username)} shape="circle" style={{ backgroundColor: getUserColor(rowData?.manager?.username), color: '#ffffff',marginRight: '5px'}} />;

  }

  function managerHeaderFilter(search, rowValue, rowData) {
    if (!search) return true;

    const managerName =  rowData?.manager?.employee?.name || rowData?.manager?.username || '';
    const normName = removeDiacritics(managerName.toLowerCase());
    const normSearch = removeDiacritics(search.toLowerCase());

    return normName.includes(normSearch);
  }

  function formatIntensityText(value) {
    if (!value) return "";

    let data;
    try {
      data = JSON.parse(value);
    } catch {
      return "";
    }

    const intensity = data.intensity || "";
    const time = data.time || "";
    
    const specialDaysMap = {
      "first_monday": t('ChecklistTemplate.SpecialDay.first_monday'),
      "first_tuesday": t('ChecklistTemplate.SpecialDay.first_tuesday'),
      "first_wednesday": t('ChecklistTemplate.SpecialDay.first_wednesday'),
      "first_thursday": t('ChecklistTemplate.SpecialDay.first_thursday'),
      "first_friday": t('ChecklistTemplate.SpecialDay.first_friday'),
      "last_monday": t('ChecklistTemplate.SpecialDay.last_monday'),
      "last_tuesday": t('ChecklistTemplate.SpecialDay.last_tuesday'),
      "last_wednesday": t('ChecklistTemplate.SpecialDay.last_wednesday'),
      "last_thursday": t('ChecklistTemplate.SpecialDay.last_thursday'),
      "last_friday": t('ChecklistTemplate.SpecialDay.last_friday'),
    };

    switch (intensity) {
      case "denne":
        return t('Checklist.Intensity.DailyTpl', { time });
      case "tyzdenne":
        const days = data.daysOfWeek || [];
        const daysStr = Array.isArray(days) ? days.join(", ") : days;
        return t('Checklist.Intensity.WeeklyTpl', { days: daysStr, time });
      case "mesacne":
        if (data.dayMonth) {
          const label = specialDaysMap[data.dayMonth] || data.dayMonth;
          return t('Checklist.Intensity.MonthlySpecialTpl', { day: label, time });
        } else if (data.daysOfMonth) {
          return t('Checklist.Intensity.MonthlyDayTpl', { day: data.daysOfMonth, time });
        }
        return t('Checklist.Intensity.MonthlyTimeTpl', { time });
      case "rocne":
        const dayR = data.day || "";
        const month = data.month || "";
        return t('Checklist.Intensity.YearlyTpl', { day: dayR, month, time });
      case "viackrat_den":
        const times = Array.isArray(data.times) ? data.times.join(", ") : data.times;
        return t('Checklist.Intensity.MultiDailyTpl', { times });
      case "nahodne":
        return t('Checklist.Intensity.Random');
      default:
        return intensity;
    }
  }

    function IntensityFormatter(cell) {
        const value = cell.getValue();
        return formatIntensityText(value);
    }

    function intensityHeaderFilter(headerValue, rowValue) {
      if (!headerValue) return true;

      const formatted = formatIntensityText(rowValue);
      const normFormatted = removeDiacritics(formatted.toLowerCase());
      const normSearch = removeDiacritics(headerValue.toLowerCase());

      return normFormatted.includes(normSearch);
    }

    function diacriticInsensitiveFilter(headerValue, rowValue) {
        if (!headerValue) return true;
        if (!rowValue) return false;
        const normalize = str =>
            str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
        return normalize(rowValue.toString()).includes(normalize(headerValue.toString()));
    }

  const [columns,setColumns] = useState([
    { formatter:"rowSelection", titleFormatter:"rowSelection", hozAlign:"center", width: 44, headerSort:false, resizable:false},
    { hozAlign:"center", width: 44, headerSort:false,formatter: reactFormatter(<EditRowFormatter/>),resizable:false},
    { title: t('Common.Name'), field: "name", headerFilter: "input",headerFilterFunc: diacriticInsensitiveFilter, minWidth: 200, widthGrow:1},
    { title: t('Common.Machine'), field: "machine.name", headerFilter: "input", headerFilterFunc: diacriticInsensitiveFilter, minWidth: 200, widthGrow:1},
    { title: t('Common.Department'), field: "custom_department",headerFilter: "input",headerFilterFunc: departmentFilter, minWidth: 190, widthGrow:1, formatter: reactFormatter(<DepartmentFormatter />),},
    { title: t('Common.Employee'), field: "users",headerFilter: "input",headerFilterFunc: userFilter, minWidth: 190, widthGrow:1, formatter: reactFormatter(<UserFormatter />),},
    { title: t('ChecklistTemplate.Column.Intensity'),field: "sending_data",formatter: IntensityFormatter,headerFilter: "input",headerFilterFunc: intensityHeaderFilter, minWidth: 190, widthGrow:1},
    { title: t('Checklist.ResponsibleManager'), field: "manager_name", minWidth: 200, widthGrow:1, formatter: reactFormatter(<ManagerFormatter />),headerFilter: "input",headerFilterFunc: managerHeaderFilter,},
    { title: t('ChecklistTemplate.Column.ManagerDueDays'), field: "manager_due_days", headerFilter: "number", minWidth: 190, widthGrow:1},
    { title: t('Common.Description'), field: "description", headerFilter: "input",headerFilterFunc: diacriticInsensitiveFilter, minWidth: 200, widthGrow:1},
    ]);


function addNewDepartment(){
  if (!canCreate) return;
  dispatch({type:'create_new_tab',name:t('Checklist.NewRecord'), translationKey: 'Checklist.NewRecord', legacyLabel: t('Checklist.NewRecord'), page:'ChecklistRecordAdd',props:{checklist_template: null,type:'add'},mask:'chck004'})
}
function copyDepartment(){
  if (!canCreate) return;
  const row = ref.current.getSelectedData()[0];
  const props = { checklist_template: row, type: 'add' };
  if (row?.original_user_id != null) props.original_user_id = row.original_user_id;
  dispatch({type:'create_new_tab',name:t('Checklist.NewRecord'), translationKey: 'Checklist.NewRecord', legacyLabel: t('Checklist.NewRecord'), page:'ChecklistRecordAdd',props,mask:'chck004'})
}
function editDepartment(){
  if (!canCreate) return;
  const row = ref.current.getSelectedData()[0];
  const props = { checklist_template: row, type: 'edit' };
  if (row?.original_user_id != null) props.original_user_id = row.original_user_id;
  dispatch({type:'create_new_tab',name:t('Checklist.EditRecord'), translationKey: 'Checklist.EditRecord', legacyLabel: t('Checklist.EditRecord'), page:'ChecklistRecordAdd',props,mask:'chck004'})
}


const scrollToFirst = () => scrollToFirstUtil(ref.current);
  const scrollUp = () => scrollUpUtil(ref.current);
  const scrollDown = () => scrollDownUtil(ref.current);
  const scrollToLast = () => scrollToLastUtil(ref.current);

  const resetMask = () => resetTabulatorMask({
    page: 'ChecklistRecordList',
    defaultColumnsVisible: DEFAULT_COLUMNS_VISIBLE_RECORD,
    ref,
    columns,
    setColumnsVisible,
  });

 const itemRenderer = (item, options) => (
    <a className="flex align-items-center px-3 py-2 cursor-pointer items-center bg-[#333] text-white w-[180px]" onClick={options.onClick}>
        <span className={`${item.icon} text-primary`} />
        <span className={`mx-2 ${item.items && 'font-semibold'}`}>{item.label}</span>
        {item.shortcut && <span className="ml-auto border-1 surface-border border-round surface-100 text-xs p-1">{item.shortcut}</span>}
    </a>
  );

  const [expandedKeys, setExpandedKeys] = useState({});

  const handleClickOutside = (event) => {
    if (overlayRef.current && !overlayRef.current.contains(event.target)) {
        setExpandedKeys({});
    }
  };

  useEffect(() => {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
          document.removeEventListener('click', handleClickOutside, true);
      };
  }, []);

    const items = [
    {
      key: '0',
      label: t('Common.Actions'),
      icon: 'pi pi-sliders-v',
      template: itemRenderer,
      items: [
            {
              key: '0_1',
              label: t('Common.SetFilter'),
              icon: 'pi pi-filter',
              command: () => {setUserMaskFilter("ChecklistRecordList","set_filters",null,ref.current.getHeaderFilters(),null);},
              template: itemRenderer,
          },
            {
              key: '0_2',
              label: t('Common.ClearFilter'),
              icon: 'pi pi-filter-slash',
              command: () => {setUserMaskFilter("ChecklistRecordList","set_filters",null,[],null);ref.current.clearHeaderFilter();},
              template: itemRenderer,
          },
          {
              key: '0_3',
              label: t('ServiceTask.SetSort'),
              icon: 'pi pi-sort-alt',
              command: () => {setUserMaskFilter("ChecklistRecordList","set_sorters",null,null,null,ref.current.getSorters());OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_4',
              label: t('Common.ClearSorting'),
              icon: 'pi pi-sort-alt-slash',
              command: () => {setUserMaskFilter("ChecklistRecordList","set_sorters",null,null,null,[]);ref.current.setSort([]);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_5',
              label: t('Common.SetMask'),
              icon: 'pi pi-server',
              command: () => {setMaskVisible(true);OverflowMenuProvider.setVisible(null);setExpandedKeys({});},
              template: itemRenderer,
          },
          {
              key: '0_5b',
              label: t('Common.ResetUserMask'),
              icon: 'pi pi-refresh',
              command: () => { resetMask(); OverflowMenuProvider.setVisible(null); setExpandedKeys({}); },
              template: itemRenderer,
          },
          {
              key: '0_6',
              label: t('Common.Notifications'),
              icon: 'pi pi-envelope',
              command: () => {openChosenNotificationPreferences('ChecklistRecordList');OverflowMenuProvider.setVisible(null);},
              template: itemRenderer,
          },
      ]
    }
  ];function changeMarkings(value){
    const columnVisible = {...columnsVisible};
    for(let val in columnVisible) {
      if(columnVisible[val]!=="id" || columnVisible[val]!=="editor"){
        columnVisible[val]=value;
        ref.current.showColumn(`${val}`);
      }
    };
    setColumnsVisible(columnVisible);
    setTimeout(() => {
      ref.current.redraw(true);
    }, 0);
  }

  function setMask(item,value){
    const columnVisible = {...columnsVisible};
   columnVisible[item] = value;
    for(const val in columnVisible) {
      if(columnVisible[val]==false){
        ref.current.hideColumn(`${val}`);
      }
      else{
        ref.current.showColumn(`${val}`);
      }
    }
    setColumnsVisible(columnVisible);
    setTimeout(() => {
      ref.current.redraw(true);
    }, 0)
  }


    return(
        <>
    <div className='w-full h-10 flex flex-row bg-[#333]'>
      <IntersectionObserverWrapper>
        {/*<div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="add"><button onClick={() => addNewDepartment()}><AddIcon/></button></div>*/}
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="edit"><button className="disabled:opacity-25" disabled={editIcon} onClick={() => editDepartment()}><EditIcon/></button></div>
        {/*<div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="copy"><button className="disabled:opacity-25" disabled={copyIcon} onClick={() => copyDepartment()}><CopyIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="delete"><button className="disabled:opacity-25" onClick={confirm} disabled={deleteIcon}><DeleteIcon/></button></div>*/}
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="print"><button onClick={() => ref.current.print(false, true)}><PrintIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="search"><button onClick={() => setVisibleSearch(true)}><SearchIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="export"><button onClick={() => ref.current.download("xlsx", "data.xlsx", {sheetName:"MyData"})}><ExportIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="first"><button onClick={() => scrollToFirst()}><BackToFirstIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="back"><button onClick={() => scrollUp()}><BackIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="forward"><button onClick={() => scrollDown()}><ForwardIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="last"><button onClick={() => scrollToLast()}><ForwardToLastIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="favorite"><button className="disabled:opacity-25" disabled={favoriteIcon} onClick={() => openFavoriteDialog(t('Checklist.Templates'),"ChecklistRecordList")}><FavoriteIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="price"><button onClick={() => setFastView("ChecklistRecordList")}><PriceIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'  data-targetid="vert"><VerticalLineIcon/></div>
        <div className="card flex justify-content-center z-[100]" data-targetid="actions" ref={overlayRef}>
          <PanelMenu model={items} expandedKeys={expandedKeys} onExpandedKeysChange={setExpandedKeys} className="w-full md:w-20rem"/>
        </div>
        </IntersectionObserverWrapper>
      </div>
<div className="flex flex-col overflow-hidden min-h-[calc(100vh-177px)]">
  <div className="">
    <div className="inline-block w-full py-2">
    <div ref={elementRef}>
      <ReactTabulator
      data={state.checklist_template_records} 
      className='h-[calc(100vh_-_193px)]' //176px
      onRef={(r) => (ref.current = r.current)}
      columns={columns}
      events={{
        rowClick: rowClick,
        rowSelectionChanged: onSelectRow,
        tableBuilt: () => {
          let mask = state.user_mask_filters.filter(mask => mask.page=="ChecklistRecordList");
          const safeParse = (v, fallback) => {
              if (v === null || v === undefined) return fallback;
              if (typeof v === "string") {
              try { return JSON.parse(v); } catch { return fallback; }
              }
              return v; // už je array/object
          };
          if (mask.length > 0) {
              const attributes  = safeParse(mask[0].attributes, []);
              const filters     = safeParse(mask[0].filters, []);
              const sorters     = safeParse(mask[0].sorters, []);
              const json_columns = safeParse(mask[0].columns, {});
              if (Array.isArray(attributes) && attributes.length > 1) {
                  ref.current.setColumnLayout(attributes);
              }
              if (Array.isArray(filters)) {
                  filters.forEach(f => ref.current.setHeaderFilterValue(f.field, f.value));
              }
              if (Array.isArray(sorters) && sorters.length > 0) {
                  ref.current.setSort(sorters);
              }
              if (json_columns && typeof json_columns === "object") {
                  setColumnsVisible(json_columns);
                  for (let column in json_columns) {
                      if (json_columns[column] === false) ref.current.hideColumn(column);
                      else ref.current.showColumn(column);
                  }
              }
          }
        },
        columnMoved:() => {
          setUserMaskFilter("ChecklistRecordList","column_move",null,null,ref.current.getColumnLayout());
        },
        columnResized: () => {
          setUserMaskFilter("ChecklistRecordList", "column_resized", null, null, ref.current.getColumnLayout());
        }
      }}
      options={{layout:"fitColumns",renderHorizontal:"virtual",rowHeight:42,movableColumns: true,
      printAsHtml:true,
      printHeader: () => buildCanonicalPrintHeaderHtml({
        branding: state?.branding,
        productFallbackSrc: defaultProductLogoSrc,
        companySettingsPrint: state?.company_settings_print,
        moduleSettings: state?.module_settings,
        title: t('Print.Title.ChecklistRecordList'),
        printDateLabel: t('Print.DateLabel'),
      }),
      printFooter: () => buildCanonicalPrintFooterHtml({ companySettingsPrint: state?.company_settings_print }),
      printRowRange:"active",
      autoResize:true}}/> 
    </div> 
      </div>
    </div>
          <Dialog header={t('Common.SearchInList')} visible={visibleSearch} style={{ width: '40vw' }} onHide={() => setVisibleSearch(false)}>
            <div className="flex flex-columns">
              
              <input
                  value={searchValue} onChange={e => setSearchValue(e.target.value)}
                  type="text"
                  className="block w-full px-4 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
              />
              <button onClick={() => searchTable()} className='w-16 ml-8 px-4 py-2 tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'><SearchIcon/></button>
            </div>
          </Dialog>
          <Dialog header={t('Common.SetMask')} visible={maskVisible} style={{ width: '70vw' }} onHide={() => setMaskVisible(false)}>
                  <div className="flex flex-col">
                  <button type="button" onClick={() => {changeMarkings(!markUnmark);setMarkUnmarked(!markUnmark);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-700 rounded-md hover:bg-zinc-500'>{markUnmark ? t('Common.DeselectAllUpper') : t('Common.SelectAllUpper')}</button>
                  {columns.map(function(item, index){ 
                    if(index<2) return null;
                              return <div 
                                  key={index} 
                                  className="flex flex-row border border-black rounded-md p-2 m-1"
                              > 
          
                                   <Checkbox onChange={(e) => setMask(item.field,e.checked)} checked={columnsVisible[item.field]}></Checkbox><span className="ml-2">{item.title}</span>
                                    
                                  {/* Use the React icon component */} 
                              </div> 
                          })} 
                      <button onClick={() => {setUserMaskFilter("ChecklistRecordList","set_columns",columnsVisible,null,null);setMaskVisible(false);}} className='m-1 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700 focus:outline-none focus:bg-zinc-600'>{t('TaskTemplateList.MaskSave')}</button>
                  </div>
                </Dialog>
                
  </div>
 </>
    )

}